/// <amd-module name="TFS/Admin/Views/OrganizationAad/Components/AadGroupOrUserPill" />

import React = require("react");
import { Pill, PillVariant, PillSize } from "VSSUI/Pill";
import { IAadObject } from "TFS/Admin/OrganizationAadCommon/Contracts/DataModels";

export interface IAadGroupOrUserPillComponentProps {
    orgPolicyToggleEnabled: boolean;
    identity: IAadObject;
    index: number;
    onRemove: (objectId: string) => void;
}

export class AadGroupOrUserPillComponent extends React.Component<IAadGroupOrUserPillComponentProps> {
    public render(): JSX.Element {
        return (
            <Pill
                variant={PillVariant.outlined}
                size={PillSize.large}
                key={this.props.index}
                onRemoveClick={this.props.orgPolicyToggleEnabled === true ? this._onRemoveAadGroup : undefined}
                iconProps={{ iconName: this.props.identity.isUser ? "Contact" : "Group" }}
            >
                {this.props.identity.displayName}
            </Pill>
        );
    }

    private _onRemoveAadGroup = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        this.props.onRemove(this.props.identity.objectId);
    };
}
